module.exports = __webpack_public_path__ + "media/images/staging_header-010bb9e97609d1b198a5aa7055cbb0ea.jpg";